"use client";

import axios from "axios";
import { getAccessToken } from "@privy-io/react-auth";
import configs from "./configs";

// Create an Axios instance with default configuration
const apiClient = axios.create({
  baseURL: configs.API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// // Attach to each request
// apiClient.interceptors.request.use(
//   async (config) => {
//     const accessToken = await getAccessToken();
//     if (accessToken && config.headers) {
//       config.headers["Authorization"] = `Bearer ${accessToken}`;
//     }
//     return config;
//   },
//   (error) => Promise.reject(error),
// );

const appClient = axios.create({
  baseURL: "",
  headers: {
    "Content-Type": "application/json",
  },
});

const pythClient = axios.create({
  baseURL: configs.TRITON_PYTHNET_API,
  headers: {
    "Content-Type": "application/json",
  },
});

export { apiClient, appClient, pythClient };

export const authorizedApiClient = async () => {
  const accessToken = await getAccessToken();
  const client = axios.create({
    baseURL: configs.API_BASE_URL,
    headers: {
      "Content-Type": "application/json",
      ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
    },
  });

  return client;
};

export const demoAuthorizedApiClient = async () => {
  const accessToken =
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiI2OTY5Njk2OTY5IiwibmFtZSI6IlNoaXQgeW91IHRyaWVkIHRvIGRlY29kZSB0aGlzPyIsImFkbWluIjoibm9wZSIsImlhdCI6MTUxNjIzOTAyMn0.FxP6p062hBnkOSjQoSOjr-rzomtvpm9zDxolYwmfd-8";
  const client = axios.create({
    baseURL: configs.API_BASE_URL,
    headers: {
      "Content-Type": "application/json",
      ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
    },
  });
  try {
    const masked = `${accessToken.slice(0, 6)}...${accessToken.slice(-6)}`;
    console.info(
      "[API] demoAuthorizedApiClient Authorization (HARDCODED DEMO):",
      `Bearer ${masked}`,
    );
  } catch {}
  return client;
};
